import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { PremiumPreviewData, PremiumPreviewStatus } from '../store/schema/PremiumPreviewData';
import { UpsellSkittleCalloutBasicText } from './UpsellSkittleCalloutBasicText';
import { UpsellSkittleCalloutBasicTextActivated } from './UpsellSkittleCalloutBasicTextActivated';
import { premiumPreviewEndedText } from './SkittleCallout.locstring.json';
import loc from 'owa-localize';

const styles = require('./UpsellSkittle.scss');

export interface UpsellSkittleCalloutTextProps {
    premimumFlagsFound: number;
    premiumCategories: string;
    premiumPreviewData: PremiumPreviewData;
    upsellClicked: () => void;
}

const UpsellSkittleCalloutText = observer(function UpsellSkittleCalloutText(
    props: UpsellSkittleCalloutTextProps
) {
    const { premimumFlagsFound, premiumCategories, premiumPreviewData, upsellClicked } = props;
    const { premiumPreviewStatus } = premiumPreviewData;
    if (premiumPreviewStatus === PremiumPreviewStatus.Activated) {
        return <UpsellSkittleCalloutBasicTextActivated premiumPreviewData={premiumPreviewData} />;
    }
    if (premiumPreviewStatus === PremiumPreviewStatus.Expired) {
        return (
            <div className={styles.skittleCalloutTextContainer}>
                <div>{loc(premiumPreviewEndedText)}</div>
            </div>
        );
    } else {
        return (
            <UpsellSkittleCalloutBasicText
                premimumFlagsFound={premimumFlagsFound}
                premiumCategories={premiumCategories}
                upsellClicked={upsellClicked}
            />
        );
    }
});

export { UpsellSkittleCalloutText };
